import { Poppins } from "next/font/google";
import Link from "next/link";
import { useEffect, useState } from "react";

const poppins = Poppins({
  subsets: ["latin"],
  weight: ["400", "500", "600", "700", "800", "900"],
});

const PopUpPasserPanier = ({
  showPopUpPasserPanier,
  setShowPopUpPasserPanier,
}) => {
  const [progress, setProgress] = useState(100); // start at 100%

  useEffect(() => {
    if (showPopUpPasserPanier) {
      setProgress(100); // reset progress each time popup opens
      const interval = setInterval(() => {
        setProgress((prev) => {
          if (prev <= 0) {
            clearInterval(interval);
            setShowPopUpPasserPanier(false); // hide when finished
            return 0;
          }
          return prev - 1; // decrease 1% every 100ms → 10s total
        });
      }, 100);

      return () => clearInterval(interval);
    }
  }, [showPopUpPasserPanier, setShowPopUpPasserPanier]);

  if (!showPopUpPasserPanier) return null;

  return (
    <div className="fixed flex flex-col justify-between  w-full lg:w-fit right-0 lg:right-2 bottom-5 bg-white rounded-[33px] text-white text-lg font-normal  px-7 z-20 shadow-[0_0_10px_rgba(0,0,0,0.1)]">

      <div className="flex flex-row pt-11 pb-10 gap-3">
        <button
          onClick={() => setShowPopUpPasserPanier(false)}
          className="bg-[#4A4A4A] border-2 border-white outline outline-1 outline-black px-4 py-1 rounded-2xl shadow-[0_0_12px_rgba(0,0,0,0.6),inset_0_2px_4px_rgba(255,255,255,0.3)]"
        >
          Continuer mes achats
        </button>
        <Link href={"/panier"}>
          <button className="bg-[#CC0001] border-2 border-white outline outline-1 outline-black px-8 py-1 rounded-2xl shadow-[0_0_12px_rgba(0,0,0,0.6),inset_0_2px_4px_rgba(255,255,255,0.3)]">
            Passer au panier
          </button>
        </Link>
      </div>

      {/* Progress line */}
      <div className="w-full h-1 bg-gray-300 rounded-full overflow-hidden mb-4">
        <div
          className="h-full bg-[#CC0001] transition-all duration-100 ease-linear"
          style={{ width: `${progress}%` }}
        />
      </div>
      
    </div>
  );
};

export default PopUpPasserPanier;
